import Keycloak from "keycloak-js";
import {config} from './Constants';

const keycloak = new Keycloak({
  url: config.keycloakInit.url, //"https://cloak.sitecenter.org/auth",
  realm: config.keycloakInit.realm,// "sitecenter",
  clientId: config.keycloakInit.clientId// "sitecenter-web",
});

export default keycloak;